import { render, staticRenderFns } from "./QRCodeScanner.vue?vue&type=template&id=af85e3e2&scoped=true&"
import script from "./QRCodeScanner.vue?vue&type=script&lang=js&"
export * from "./QRCodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRCodeScanner.vue?vue&type=style&index=0&id=af85e3e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af85e3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VToolbar,VToolbarTitle})
